export function validConfig(config) {
    return (config != null &&
        config.writeKey != null &&
        config.writeKey?.length > 0 &&
        config.dataPlaneUrl != null &&
        config.dataPlaneUrl.length > 0);
}
//# sourceMappingURL=types.js.map